import { db } from '@/services/storage/db';
import type { ChecklistTemplate } from '@/types/checklist-template';

export async function duplicateTemplate(id: string): Promise<ChecklistTemplate> {
  const original = await db.getTemplate(id);
  if (!original) throw new Error(`Template not found: ${id}`);

  // Build a UUID mapping for every task so dependency IDs can be remapped
  const idMap = new Map<string, string>(
    original.tasks.map((t) => [t.id, crypto.randomUUID()]),
  );

  const tasks = original.tasks.map((t) => ({
    ...t,
    // SAFETY: idMap has an entry for every task id built from original.tasks above
    id: idMap.get(t.id)!,
    templateId: '', // will be reassigned by createTemplate
    dependsOn: t.dependsOn.map((depId) => idMap.get(depId) ?? depId),
  }));

  return db.createTemplate({
    name: `Copy of ${original.name}`,
    description: original.description,
    seasonType: original.seasonType,
    region: original.region,
    isBuiltIn: false,
    version: 1,
    tasks,
  });
}
